import styled, { css } from 'styled-components';

export const TableCell = styled.div`
    align-self: flex-start;
    padding: 1rem 0;
`;

export const TableAction = styled.a`
    color: #000;
    margin-right: .5rem;

    &:hover {
        color: #666;
    }
`;

export const PageTitle = styled.h1`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 2.25rem;
    margin: 2rem 0;
`;

export const FormSection = styled.div`
    margin-bottom: 5rem;
`;

export const FormSectionTitle = styled.h2`
    font-size: 1.75rem;
    margin-bottom: 1rem;
`;

export const FormSectionFields = styled.div`
    border-top: 1px solid #000;
    padding: 1rem 0;
`;

export const FormSectionField = styled.div<{ isCheckboxes? }>`
    padding: 1rem 0;

    ${({ isCheckboxes }) =>
        isCheckboxes &&
        css`
            padding-left: 19rem;
        `}
`;

export const FormLabel = styled.label`
    display: inline-block;
    width: 100%;
    max-width: 19rem;
    margin-right: 1rem;
    text-align: right;
    font-size: 1.4rem;
`;

export const TextInput = styled.input`
    width: 100%;
    max-width: 30rem;
    font-size: 1.4rem;
    padding: 0.5rem 1rem;
    border-radius: 0.3rem;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
`;

export const SelectInput = styled.select`
    width: 100%;
    max-width: 30rem;
    font-size: 1.4rem;
    padding: 0.5rem 1rem;
    border-radius: 0.3rem;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
`;

export const Checkbox = styled.div`
    padding: 0.35rem 0;
    font-size: 1.45rem;
`;

export const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
